export default __webpack_public_path__ + "static/media/Savant's Belt of the Forbidden Art.c1830b18.jpg";